import { render } from "./AddressField.vue?vue&type=template&id=13fce0ad&scoped=true"
import script from "./AddressField.vue?vue&type=script&lang=js"
export * from "./AddressField.vue?vue&type=script&lang=js"

import "./AddressField.vue?vue&type=style&index=0&id=13fce0ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13fce0ad"]])

export default __exports__